
        Component.define('section-slider', (el, params) => {
            /**
 * Cada componente recebe as variáveis explicadas abaixo
 *
 * @param {HTMLElement} el - Elemento DOM que seleciona o componente em si
 * @param {Object} params  - Parâmetros para serem utilizados
 */

const $el         = $(el);
const $slide      = $('.wrapper-slider');

$slide.slick({
    infinite      : true,
    slidesToScroll: 1,
    dots          : true,
    arrows        : false,
    autoplay      : true,
    autoplaySpeed : 5000,
});

        });